//Not Found Screen NextUI
import { Container, Button, Text} from '@nextui-org/react'
import React from 'react'
import { useNavigate } from "react-router-dom";


const NotFound = () => {
    const navigate = useNavigate();

    return (
        <Container>
            <Text
                h1
                size={60}
                css={{
                textGradient: "45deg, $blue600 -20%, $pink600 50%",
                }}
                weight="bold"
            >
            Erreur 404 - Page non trouvée
            </Text>  
            <Button onClick={() => navigate("/dashboard")}>Retour</Button>
        </Container>
    )
}

export default NotFound






